
export type GetTweetFeed200TweetsItemMediaItemDimensions = {
  height?: number;
  width?: number;
};
